import React from 'react';

import Button from 'CommonComponents/Button';

export default function SupplierContractTermPartiesTable(props) {
    if (!props.parties?.length) {
        return (
            <Button small as="a" href={props.suppliersIndexUrl}>
                {$t('Add key personnel')}
            </Button>
        );
    }

    return (
        <div className="suppliers-table table-responsive shadow">
            <table className="table table-bordered no-footer text-center m-0 font-weight-bold">
                <thead>
                    <tr className={'text-blue bg-white'}>
                        <th style={{ width: '40%' }} className="border-top-0 border-left-0">
                            {$t('Name')}
                        </th>
                        <th style={{ width: '30%' }} className="border-top-0">
                            {$t('Position')}
                        </th>
                        <th style={{ width: '30%' }} className="border-top-0 border-right-0">
                            {$t('Role')}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {props.parties.map((party) => {
                        return (
                            <tr key={party.id} className="bg-grey2">
                                <td className="border-bottom-0 border-left-0">{party.name}</td>
                                <td className="border-bottom-0">{party.position}</td>
                                <td className="border-bottom-0 border-right-0">{party.role}</td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
}
